import { ChevronLeft } from "@mui/icons-material";
import { Divider, IconButton, Toolbar, Box, Typography, Paper, List, ListItem, ListItemButton } from "@mui/material";
import React from "react";
import { StyledDrawer } from "../../StyledDrawer";
import routes from "../../routes.json"
import { useNavigate } from "react-router-dom";

export default function LivrarePage({open, setOpen, toggleDrawer}) {

    const navigate = useNavigate();

    React.useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return(
        <React.Fragment>
            <StyledDrawer variant="permanent" open={open} id="drawer-main" >
                <Toolbar
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        px: [1],
                    }}
                >
                <IconButton onClick={toggleDrawer}>
                    <ChevronLeft color="custom" />
                </IconButton>
                </Toolbar>
                <Divider color="#e5d96b" sx={{width: "90%", mx: "auto"}} />
                <List>
                {
                    routes.drawer.map((route) =>
                        <ListItem key={"drawer-route-" + route.name}>
                            <ListItemButton
                                sx={{
                                    color: "custom.main",
                                }}
                                className="drawer-item"
                                onClick={() => { navigate(route.location); setOpen(false); }}
                            >
                                { route.name }
                            </ListItemButton>
                        </ListItem>
                    )
                }
                </List>
            </StyledDrawer>
            <Paper
                sx={{
                    width: "98vw",
                    m: "auto",
                    backgroundColor: "#edebeb"
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        pt: 5
                    }}
                >
                    <Typography
                        sx={{
                            fontFamily: "titleFont",
                            m: "auto",
                            fontWeight: "bold",
                            fontSize: {xs: "2.5rem", md: "4rem"},
                            textAlign: "center"
                        }}
                        color="custom2.main"
                    >
                        ~~Livrare~~
                    </Typography>
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        px: 5,
                        pb: 5
                    }}
                >
                    <Typography
                        sx={{
                            m: "auto",
                            textAlign: "center"
                        }}
                        variant="h6"
                    >
                        In prezent, livram produsele prin curier rapid in toata tara. Transportul este gratuit pentru toate comenzile, iar comanda minima este de 4kg de produse (in total).
                    </Typography>
                </Box>
            </Paper>
        </React.Fragment>
    )
}